import { Loader } from "../gateway/Loader/Loader";
import { Serie } from "../gateway/Serie/Serie";

export class SetSerieConstantUsecase {
    constructor() {
        this.LoaderGateway = new Loader();
        this.SerieGateway = new Serie();
    }

    async execute({
        companyId,
        accountingId,
        base,
        value,
        scenarioId,
        rateId
    } = {}) {
        const payload = this.sanitizeInput({
            companyId,
            accountingId,
            base,
            value,
            scenarioId,
            rateId
        });
        if (!payload.companyId || !payload.accountingId) return null;
        if (payload.value === null) return null;
        if (!payload.scenarioId) return null;
        if (!payload.rateId) return null;
        const serieRate = this.getSerieRate({ rateId: payload.rateId });
        if (!serieRate) return null;
        payload.serie = serieRate;
        payload.sourceSerieId = serieRate.sources[0];
        try {
            const { response } = await this.LoaderGateway.setConstant(payload);
            if (response) return "Taxa atualizada!";
        } catch (error) {
            return `Erro ao atualizar taxa: ${error.message}`;
        }
    }

    sanitizeInput({
        companyId = "",
        accountingId = "",
        base = null,
        value = null,
        scenarioId = "",
        rateId = ""
    } = {}) {
        const sanitizedCompanyId = String(companyId).trim();
        const sanitizedAccountingId = String(accountingId).trim();
        const sanitizedScenarioId = String(scenarioId).trim() || "ORIGINAL";
        const sanitizedValue =
            value === null || value === undefined ? null : Number(value);
        const sanitizedBase = base && typeof base === "object" ? base : null;
        const fallbackBase =
            sanitizedCompanyId && sanitizedAccountingId
                ? {
                      companyId: sanitizedCompanyId,
                      accountingId: sanitizedAccountingId
                  }
                : null;
        const sanitizedRateId = String(rateId).trim();
        return {
            companyId: sanitizedCompanyId || null,
            accountingId: sanitizedAccountingId || null,
            base: sanitizedBase || fallbackBase,
            value:
                sanitizedValue === null || Number.isNaN(sanitizedValue)
                    ? null
                    : sanitizedValue,
            scenarioId: sanitizedScenarioId || null,
            rateId: sanitizedRateId || null
        };
    }

    getSerieRate({ rateId } = {}) {
        return this.SerieGateway.findOneCollection({
            _id: rateId,
            type: "constant"
        });
    }
}
